import*as React from'react';var OverallSituationCountPane=function OverallSituationCountPane(props){var countFontStyle={fontSize:'3.5rem'};return<>
      <div className="flow-column mb-3 shadow">
        <div className="bg-primary text-white py-1 text-center rounded-top">
          全体状況
        </div>
        <div className="border border-panel-border border-top-0 rounded-bottom shadow bg-white">
          <div className="container d-flex flex-row pb-3">
            <div className="text-primary border-right border-panel-border d-flex flex-column flex-grow-1">
              <div className="text-right mb-0 pt-2 pr-2"style={countFontStyle}>{props.userCount}</div>
              <div className="text-right pr-2">報告者数</div>
            </div>
            <div className="text-danger d-flex flex-column flex-grow-1">
              <div className="text-right mb-0 pt-2 pr-2"style={countFontStyle}>{props.damageCount}</div>
              <span className="text-right  pr-2">被害あり</span>
            </div>
          </div>
        </div>
      </div>
    </>;};export default OverallSituationCountPane;